import { useState } from 'react';
import { useGetVerifiedSchools } from '@/api/hooks';
import { useEstablishmentStore } from '@/store/EstablishmentStore/EstablishmentStore';
import { useEstablishmentActions } from './useEstablishmentActions';
import { useEstablishmentData } from './useEstablishmentData';

// Hook principal pour la gestion des établissements
export const useEstablishments = () => {
  // === ÉTATS LOCAUX ===
  const [selectedEstablishments, setSelectedEstablishments] = useState<
    string[]
  >([]);
  const [establishmentListLimit, setEstablishmentListLimit] = useState(10);
  const [establishmentListPage, setEstablishmentListPage] = useState(1);

  // === STORE ZUSTAND ===
  const {
    openEstablishmentModal,
    setOpenEstablishmentModal,
    isOpenEstablishmentDeletionModal,
    isOpenEstablishmentSendMailModal,
    selectedEstablishmentId,
    setSelectedEstablishmentId,
    selectedEstablishmentEmail,
    setSelectedEstablishmentEmail,
  } = useEstablishmentStore();

  // === DONNÉES DE L'API ===
  const { data: establishments, isLoading } = useGetVerifiedSchools({});

  // === HOOKS SPÉCIALISÉS ===
  const establishmentActions = useEstablishmentActions(establishments);

  // === GESTION DE LA SÉLECTION ===
  const handleEstablishmentSelection = (id: string) => {
    setSelectedEstablishments((prev) =>
      prev.includes(id)
        ? prev.filter((establishmentId) => establishmentId !== id)
        : [...prev, id],
    );
  };

  // === FORMATAGE DES DONNÉES ===
  const { columns, formattedData } = useEstablishmentData(
    establishments,
    selectedEstablishments,
    handleEstablishmentSelection,
    establishmentActions.createActionsMenu,
  );

  // === ACTIONS PRINCIPALES ===
  const handleAddEstablishment = () => {
    setOpenEstablishmentModal(true);
  };

  // Wrapper pour l'envoi de mail avec nettoyage
  const handleSendMailAction = async () => {
    await establishmentActions.executeSendMail(
      selectedEstablishmentEmail,
      selectedEstablishmentId,
    );
    // Nettoyer l'état après envoi
    setSelectedEstablishmentEmail('');
    setSelectedEstablishmentId('');
  };

  return {
    // === DONNÉES ===
    columns,
    formattedData,
    establishments,
    isLoading,

    // === ÉTATS DE SÉLECTION ===
    selectedEstablishments,
    handleEstablishmentSelection,

    // === PAGINATION ===
    establishmentListLimit,
    setEstablishmentListLimit,
    establishmentListPage,
    setEstablishmentListPage,

    // === MODALS ===
    openEstablishmentModal,
    setOpenEstablishmentModal,
    isOpenEstablishmentDeletionModal,
    isOpenEstablishmentSendMailModal,
    selectedEstablishmentId,

    // === ACTIONS ===
    handleAddEstablishment,

    // Actions de désactivation/réactivation
    onDesactivateEstablishment: establishmentActions.executeToggleStatus,
    isUpdatingSchool: establishmentActions.isUpdatingSchool,
    deactivationMode: establishmentActions.deactivationMode,

    // Actions d'envoi de mail
    onSendMail: handleSendMailAction,
    isSendMailPending: establishmentActions.isSendMailPending,
  };
};
